import {
  ActionType,
  Language,
  SigningMethod,
  SourceName,
} from '../../../enums/const-enums';

export interface RassCodeSubmitTranslations {
  input: {
    label: {
      [ActionType.LOGIN]: string;
      [ActionType.SIGN]: string;
    };
    error: {
      [SigningMethod.OOB]: string;
      [SigningMethod.RABO_SCANNER]: string;
      [SigningMethod.RANDOM_READER]: string;
    };
    hint: {
      [SigningMethod.OOB]: string;
      [SigningMethod.RABO_SCANNER]: string;
      [SigningMethod.RANDOM_READER]: string;
    };
  };
  button: {
    label: Record<SourceName, string>;
  };
}

const nlTranslations: RassCodeSubmitTranslations = {
  input: {
    label: {
      [ActionType.LOGIN]: 'Inlogcode',
      [ActionType.SIGN]: 'Signeercode',
    },
    error: {
      [SigningMethod.OOB]: 'Bevestigingscode bestaat uit 6 cijfers.',
      [SigningMethod.RABO_SCANNER]: 'Bevestig met de code van 8 cijfers.',
      [SigningMethod.RANDOM_READER]: 'Bevestig met de code van 8 cijfers.',
    },
    hint: {
      [SigningMethod.OOB]: '6 cijfers van de bevestigingscode uit de SMS',
      [SigningMethod.RABO_SCANNER]:
        '8-cijferige code die op je Rabo Scanner verschijnt',
      [SigningMethod.RANDOM_READER]:
        '8-cijferige code die op je Random Reader verschijnt',
    },
  },
  button: {
    label: {
      [SourceName.EMANDATES]: 'Machtigen',
      [SourceName.IDEAL]: 'Betalen',
      [SourceName.WERO]: 'Betalen',
      [SourceName.IDIN]: 'Ondertekenen',
      [SourceName.LOGIN]: 'Inloggen',
      [SourceName.OTHER]: 'Ondertekenen',
    },
  },
};

const enTranslations: RassCodeSubmitTranslations = {
  input: {
    label: {
      [ActionType.LOGIN]: 'Login code',
      [ActionType.SIGN]: 'Sign code',
    },
    error: {
      [SigningMethod.OOB]: 'Confirmation code consists of 6 digits.',
      [SigningMethod.RABO_SCANNER]: 'Please enter the 8 digit code to confirm.',
      [SigningMethod.RANDOM_READER]:
        'Please enter the 8 digit code to confirm.',
    },
    hint: {
      [SigningMethod.OOB]: '6 digits from the confirmation code sent by text',
      [SigningMethod.RABO_SCANNER]:
        '8 digit code shown on your Rabo Scanner display',
      [SigningMethod.RANDOM_READER]:
        '8 digit code shown on your Random Reader display',
    },
  },
  button: {
    label: {
      [SourceName.EMANDATES]: 'Mandate',
      [SourceName.IDEAL]: 'Pay',
      [SourceName.WERO]: 'Pay',
      [SourceName.IDIN]: 'Sign',
      [SourceName.LOGIN]: 'Login',
      [SourceName.OTHER]: 'Sign',
    },
  },
};

export const rassCodeSubmitTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: enTranslations,
};
